import { computed, Injectable, signal } from "@angular/core";
export type TabInitStatus =
  | { status: "pending" }
  | { status: "ready" }
  | { status: "error"; error: Error };

@Injectable()
export class FormularInitTracker {
  private readonly _status = signal<Map<string, TabInitStatus>>(new Map());

  readonly errors = computed(() =>
    [...this._status().entries()]
      .filter(([, s]) => s.status === "error")
      .map(
        ([id, s]) =>
          [
            id,
            (s as Extract<TabInitStatus, { status: "error" }>).error,
          ] as const,
      ),
  );

  readonly allReady = computed(() => {
    const entries = [...this._status().values()];
    return entries.length > 0 && entries.every((s) => s.status === "ready");
  });

  register(id: string) {
    this._status.update((m) => new Map(m).set(id, { status: "pending" }));
  }

  markReady(id: string) {
    this._status.update((m) => new Map(m).set(id, { status: "ready" }));
  }

  markError(id: string, error: Error) {
    console.error(`[${id}]`, error);
    this._status.update((m) => new Map(m).set(id, { status: "error", error }));
  }
}
